/* istanbul ignore file */
import type { ProductPriceFragmentFragment } from '@packages/gql/generated/shopping/graphql';

/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { ProductPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const priceDataMock: ProductPriceFragmentFragment = {
  amount: 1337,
  currency: 'EUR',
  isStartPrice: false,
  saving: {
    type: 'CURRENCY',
    value: 1337,
  },
  unit: '$ per volume',
  uvp: true,
  value: 13999,
  valueOld: 13371337,
  valueUnit: 133,
};

export const productPriceDataMock = priceDataMock;

export function getPriceFragmentedData(data?: ProductPriceFragmentFragment) {
  return makeFragmentData(data || priceDataMock, ProductPriceFragmentFragmentDoc);
}

export const getProductPriceFragmentedData = getPriceFragmentedData;
